import * as actionTypes from "../action-types";

const initialState = {
    milanSathiProfileData: []
};

const milansathiReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_MILAN_SATHI_PROFILE:
            return { ...state, milanSathiProfileData: payload, };

        default: {
            return state;
        }
    }
};

export default milansathiReducer;